/*
Filter Properties

Property Name | Type(s) | Description | Example
--------------------------------------------------------
label | String | Label
value | Path | path to value
type | String | 'select', 'list', 'range', 'checkbox', 'switch' | the type of Filter it is
returnObject
itemValue
itemText
...v-input attributes

*/
export function certification () {
  return {
    label: 'Certification',
    value: 'certification',
    type: 'list',
    returnObject: false
  }
}

export function color () {
  return {
    label: 'Color',
    value: 'color',
    type: 'list',
    returnObject: false
  }
}

export function cut () {
  return {
    label: 'Cut',
    value: 'cut',
    type: 'list',
    returnObject: false
  }
}

export function diameter () {
  return {
    label: 'Diameter',
    value: 'diameter',
    type: 'range'
  }
}

export function finish () {
  return {
    label: 'Finish',
    value: 'finish',
    type: 'list',
    returnObject: false
  }
}

export function length () {
  return {
    label: 'Length',
    value: 'length',
    type: 'range'
  }
}

export function loadWeight () {
  return {
    label: 'Load Weight',
    value: 'loadWeight',
    type: 'range'
  }
}

export function manufacturer () {
  return {
    label: 'Manufacturer',
    value: 'manufacturer',
    type: 'list',
    returnObject: true,
    itemValue: 'id',
    itemText: 'name'
  }
}

export function species () {
  return {
    label: 'Species',
    value: 'species',
    type: 'list',
    returnObject: false
  }
}

export function thickness () {
  return {
    label: 'Thickness',
    value: 'thickness',
    type: 'range'
  }
}

export function type () {
  return {
    label: 'Type',
    value: 'type',
    type: 'list',
    returnObject: false
  }
}

export function width () {
  return {
    label: 'Width',
    value: 'width',
    type: 'range'
  }
}
